import logo from './logo.svg';
import './App.css';

function App() {
  window.location.href = '/home.html'
  return (
    <div className="App">
      
    </div>
  );
}

export default App;
